import PublicIcon from '@mui/icons-material/Public';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { useTheme as useMuiTheme } from '@mui/material';
import { Box, Typography, useTheme } from 'hephaestus/web';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export type DriftQueueFooterProps = {
  shown: number;
  total: number;
};

export const DriftQueueFooter: FC<DriftQueueFooterProps> = ({
  shown,
  total,
}) => {
  const { t } = useTranslation(['driftQueue']);
  const muiTheme = useMuiTheme();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mt: 2,
        px: 1,
      }}
    >
      <Typography variant='bodySmall' color='textSecondary'>
        {t('driftQueue:footer.rowCount', { shown, total })}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant='labelSmall' sx={{ fontWeight: 600 }}>
          {t('driftQueue:legend.title')}:
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: 0.5,
              backgroundColor: theme.color.warning,
            }}
          />
          <Typography variant='labelSmall'>
            {t('driftQueue:legend.singleBreach')}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: 0.5,
              backgroundColor: theme.color.negative,
            }}
          />
          <Typography variant='labelSmall'>
            {t('driftQueue:legend.compoundBreach')}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <ReportProblemIcon
            sx={{ fontSize: 14, color: muiTheme.palette.warning.dark }}
          />
          <Typography variant='labelSmall'>
            {t('driftQueue:legend.stale')}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <PublicIcon
            sx={{ fontSize: 14, color: theme.color.onSurfaceVariant }}
          />
          <Typography variant='labelSmall'>
            {t('driftQueue:legend.international')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
